// Must stay the first import, so Sentry starts before the rest of the app loads
import {Sentry} from "./services/sentry";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import CrashScreen from "./components/layout/CrashScreen/CrashScreen";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
    {
        // Errors React recovers from, or that escape the error boundary below, go to Sentry too
        onUncaughtError: Sentry.reactErrorHandler(),
        onRecoverableError: Sentry.reactErrorHandler(),
    }
);
root.render(
    // A render error shows a friendly screen (and goes to Sentry) instead of a blank page
    <Sentry.ErrorBoundary fallback={<CrashScreen/>}>
        <App/>
    </Sentry.ErrorBoundary>
);
